import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Switch } from 'react-router-dom';
import { RouteWithTitle } from "routes";
import { compose } from 'redux';
import { ExploreProspector } from 'components/explore/prospector';
import { AddPropertyPage } from 'components/explore/prospector';
import { ManuallyAddProperty } from 'components/explore/prospector';
import { SnackbarProvider } from 'notistack';
import { setUserLocation } from 'store/actions';
import { Constants } from 'utilities/constants';
import { getLocation } from "api/prospector/geo";
import { storeUseLocationPreference } from "api/prospector/prefs";
import FullScreenDialog from 'components/layout/FullscreenDialog';
import { SimpleDialogProvider } from 'components/explore/prospector/Dialog';
import { useJsApiLoader } from "@react-google-maps/api";
import { googleMapsApiKey } from "index";

function mapState(state) {
  return {
    userLocation: state.appState.userLocation
  };
}

const mapDispatch = dispatch => {
  return {
    setUserLocation: userLocation => dispatch(setUserLocation(userLocation))
  }
}

const scriptLibraries = ['geometry', 'places'];

function ProspectorRoutes({ userLocation, setUserLocation, history, location, setProspectorModalOpen, prospectorModalOpen, refreshProspectsGrid, setRefreshProspectsGrid }) {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey,
    libraries: scriptLibraries
  });
  const [locationStatus, setLocationStatus] = useState("pending");
  const [browserLocation, setBrowserLocation] = useState(null);

  // useEffect(() => {
  //   const useLocation = loadUseLocationPreference();
  //   if (useLocation && locationStatus === "pending") {
  //     tryGetUserLocation();
  //   }
  // }, []);
  // If any of the prospector routes are used, open it in a modal without titlebar
  useEffect(() => {
    if (location.pathname.includes(Constants.Routes.EXPLORE_PROSPECTOR)) {
      if (!prospectorModalOpen) {
        setProspectorModalOpen(true);
      }
    } else {
      setProspectorModalOpen(false);
    }
    return () => { // On Unmount, set modal to false to show main app titlebar
      setProspectorModalOpen(false);
    }
  }, []);

  function handleLocationReceived(location) {
    setBrowserLocation(location);
  }

  async function tryGetUserLocation() {
    try {
      setLocationStatus("loading");
      const loc = await getLocation();
      console.log(loc);
      setUserLocation(loc);
      handleLocationReceived(loc);
      setLocationStatus("ok");
      storeUseLocationPreference(true);
    } catch (err) {
      setLocationStatus("disabled");
      setUserLocation(null);
      console.log("error", err);
      storeUseLocationPreference(false);
    }
  }
  const prospectorModalClose = () => {
    setProspectorModalOpen(false);
    history.push(`${Constants.Routes.EXPLORE_CONDUCTOR}`);
  }

  function handleUserLocationButtonClick() {
    if (locationStatus === "pending") {
        tryGetUserLocation();
    }
    // else if (locationStatus === "ok") {
    //     setLocationStatus("pending");
    //     storeUseLocationPreference(false);
    //     setUserLocation(null);
    //     handleLocationReceived(null);
    // }
  }
  if (!isLoaded) return null;
  return (
    <SnackbarProvider maxSnack={3}>
      <SimpleDialogProvider>
        <Switch>
          <RouteWithTitle exact path={`${Constants.Routes.EXPLORE_PROSPECTOR_ADD_PROPERTY}/manual`} title={Constants.RouteTitles.EXPLORE_PROSPECTOR_ADD_PROPERTY} render={(props) => (
            <FullScreenDialog open={true} onClose={prospectorModalClose} title={'Add Prospect'}>
              <ManuallyAddProperty {...props} userLocation={userLocation} setUserLocation={setUserLocation} 
                refreshProspectsGrid={refreshProspectsGrid} setRefreshProspectsGrid={setRefreshProspectsGrid}
                handleUserLocationButtonClick={handleUserLocationButtonClick} locationStatus={locationStatus} />
            </FullScreenDialog>
          )} />
          <RouteWithTitle path={`${Constants.Routes.EXPLORE_PROSPECTOR_ADD_PROPERTY}/:placeId`} title={Constants.RouteTitles.EXPLORE_PROSPECTOR_ADD_PROPERTY} render={(props) => (
            <FullScreenDialog open={true} onClose={prospectorModalClose} title={'Add Prospect'}>
              <AddPropertyPage {...props} refreshProspectsGrid={refreshProspectsGrid} setRefreshProspectsGrid={setRefreshProspectsGrid} />
            </FullScreenDialog>
          )} />
          <RouteWithTitle path={Constants.Routes.EXPLORE_PROSPECTOR} title={Constants.RouteTitles.EXPLORE_PROSPECTOR} render={(props) => (
            <FullScreenDialog open={true} onClose={prospectorModalClose} title={'Add Prospect'}>
              <ExploreProspector {...props} browserLocation={browserLocation} />
            </FullScreenDialog>
          )} />
        </Switch>
      </SimpleDialogProvider>
    </SnackbarProvider>
  )
}
export default compose(
  connect(mapState, mapDispatch)
)(ProspectorRoutes);